import { FC, useEffect } from 'react'

/* Hooks */
import useTransactionRequestStatusPolling from '../lib/hooks/useTransactionRequestStatusPolling'

/* Components */
import { TxDetail } from './TxDetail'
import { Loading } from './Loading'

/* Constants */

/* Types */
type TransactionProps = {
  transactionRequestId: number
  layer: string
  address?: string
  successCallback?: () => void
}

const Transaction: FC<TransactionProps> = ({ transactionRequestId, successCallback }) => {
  const [transactionResult] = useTransactionRequestStatusPolling(transactionRequestId)

  useEffect(() => {
    if (transactionResult?.status === 'passed' && successCallback) {
      successCallback()
    }
  }, [transactionResult, successCallback])

  if (transactionResult?.status === 'failed') {
    return (
      <div className={'tx-message'}>
        <p className="bk-msg-error">An error occurred!</p>
        <p className="bk-msg-error">We couldn't process your request, please try again</p>
      </div>
    )
  }

  if (!transactionResult) {
    return (
      <div className={'tx-message'}>
        <Loading />
        Processing your request
      </div>
    )
  }

  return (
    <TxDetail hash={transactionResult.hash} status={transactionResult.status} chain_id={transactionResult.chain_id} />
  )
}

export default Transaction
